import getFeatures from "./getFeatures";

const getMvtParams = state => getFeatures(state).mvtParams;

export default getMvtParams;
